import React from 'react';
import SEO from '../SEO';
import HomeHero from './HomeHero';
import HomeAbout from './HomeAbout';
import HomeServices from './HomeServices';
import HomeCTA from './HomeCTA';
import HomeGallery from './HomeGallery';
import HomeFAQ from './HomeFAQ';

const Home: React.FC = () => {
  return (
    <div>
      <SEO
        title="Bizani Media"
        description="Bizani Media delivers digital storytelling, strategy and innovation. Documentary production, branding, events coverage, and project documentation across Zimbabwe and beyond."
        path="/"
        keywords="Bizani Media, digital storytelling, documentaries, Zimbabwe, media production, branding, events coverage, video production, documentary series, 3Ktv, ZBC"
      />
      <HomeHero />
      <HomeAbout />
      <HomeServices />
      <HomeCTA />
      <HomeGallery />
      <HomeFAQ />
    </div>
  );
};

export default Home;
